import { Injectable } from '@angular/core';

import { BetslipType } from '../../../../../core/betslip-type';
import { BetslipV2ParticipantPick } from '../../../../../core/picks/betslip-v2-participant-pick';
import { CriteriaType, IRewardToken } from '../../../reward-tokens.model';
import { TokenPicksValidity, TokenValidationInput, TokensCriteriaValidatorBase, picksValidity } from '../criteria-validator-base.service';

@Injectable()
export class NotParticipantBetValidator extends TokensCriteriaValidatorBase<IRewardToken, CriteriaType> {
    override type = CriteriaType.ParticipantBetSelected;

    isValid(_: IRewardToken, state: TokenValidationInput): TokenPicksValidity {
        const picks = state.selectedPicks;
        const validPicks = picks.filter((pick) => !BetslipV2ParticipantPick.isPick(pick));

        const hasValidPicks = validPicks.length > 0;

        if (state.selectedType === BetslipType.Single || state.selectedType === BetslipType.BetBuilder) {
            return picksValidity(hasValidPicks, validPicks);
        }

        return picksValidity(hasValidPicks && validPicks.length === picks.length, validPicks);
    }
}
